// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2vNXg","description":"PatientConsentPreview_description__1gs4W"};